import { SyntheticEvent, useEffect, useMemo, useState } from 'react';
import { Box, Button, ClickAwayListener, TextField, Autocomplete } from '@mui/material';
import { Search as SearchIcon, ArrowDropDown as ArrowDropDownIcon, ArrowDropUp as ArrowDropUpIcon } from '@mui/icons-material/';
import DetectMobileHelper from '../../helpers/detect-mobile.helper';
import FiltersService from '../../services/filters.service';
import { FilterOption } from '../../interfaces/FilterOption';
import { FilterNames } from '../../enums/FilterNames';
import classes from './FilterDropdownSearch.module.scss';

const FilterDropdownSearch = ({ name, setValue, value }: { name: FilterNames; setValue: (event: SyntheticEvent<Element, Event>, value: FilterOption[]) => void, value: FilterOption[] }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<FilterOption[]>([]);

  useEffect(() => {
    if (!isDropdownOpen) {
      FiltersService.getOptionsByFilterName(name)
        .then((data) => {
          setOptions(data);
        })
        .catch((err) => console.error(err));
    }
  }, [isDropdownOpen, name]);

  const renderAutocomplete = useMemo(() => {
    return <Autocomplete
      className={`${classes['search']} mt-2`}
      classes={{ option: classes['option-color'], listbox: `${classes['listbox-height']} scrollbar` }}
      options={options}
      getOptionLabel={(option) => option.name}
      multiple
      renderInput={(params) => (
        <TextField {...params} autoFocus placeholder='Search...'
          InputProps={{
            ...params.InputProps,
            classes: {
              notchedOutline: classes['autocomplete-search'],
            },
          }}
        />
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      limitTags={1}
      open={true}
      onChange={setValue}
      value={value}
      popupIcon={<SearchIcon className={`${classes['rotate-icon']} pe-1`} />}
    />
  }, [options, setValue, value]);

  const getFiltersLabel = useMemo(() => {
    if (0 < value.length) {
      return 1 === value.length
        ? value[0].name
        : `${value[0].name} + ${value.length - 1}`;
    }

    return name;
  }, [value, name]);

  return <Box>
    <Button onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      className={`button-text filter-button ${isDropdownOpen ? classes.selectedFilterButton : classes.filterButton}`}
      endIcon={isDropdownOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}>
      {getFiltersLabel}
    </Button>
    <Box>
      {isDropdownOpen && (
        DetectMobileHelper.isMobile() ? (
          <>
            {renderAutocomplete}
          </>
        ) : (
          <ClickAwayListener onClickAway={() => setIsDropdownOpen(false)} >
            {renderAutocomplete}
          </ClickAwayListener>
        )
      )}
    </Box>
  </Box >
};

export default FilterDropdownSearch;
